import { Layout, Typography } from 'antd'
import React from 'react'
import styled from 'styled-components'

const NotFound = () => {
  return (
    <Root>
      <Typography.Title
        style={{
          fontSize: 40,
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        404
        <span style={{ fontSize: 24, marginBottom: 10 }}>PAGE NOT FOUND</span>
      </Typography.Title>
    </Root>
  )
}

export default NotFound

const Root = styled(Layout)`
  height: 100vh;
  padding-top: 24em;

  &.ant-layout {
    background: #fff url("https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg") no-repeat center 110px;
    background-size: 100%;
  }
`
